import { BaseLog, BaseLogArgs } from './BaseLog';
import { LEVEL } from './LEVEL';

export function BotDefenceLog({ message, data = {}, stacktrace, level = LEVEL.INFO }: Partial<BaseLogArgs>) {
    return BaseLog({
        category: 'BD',
        message,
        data,
        level,
        stacktrace
    });
}
